import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAfterTideAuth } from '../../context/AfterTideAuthContext';
import { usePlatform } from '../../context/PlatformContext';
import { useDarkClasses } from '../../hooks/useDarkClasses';

/**
 * AfterTideRoute — wraps a shared page mounted under /aftertide/*.
 *
 * Shared pages render AfterTide content when the platform is AfterTide, so
 * this wrapper (1) switches the platform on when an /aftertide URL is opened
 * directly or from a link, and (2) enforces the 18+ age gate. It adds no
 * chrome of its own; the shared Header/Footer stay in place.
 */
export const AfterTideRoute: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const {
    isVerified
  } = useAfterTideAuth();
  const {
    isAfterTide,
    setAfterTide
  } = usePlatform();
  const location = useLocation();
  const dk = useDarkClasses();
  useEffect(() => {
    if (!isAfterTide) setAfterTide(true);
  }, [isAfterTide, setAfterTide]);
  if (!isVerified) {
    return <Navigate to="/aftertide/verify" replace state={{
      from: location.pathname + location.search
    }} data-id="element-828" data-mp="1mpjeawasrxsn" />;
  }
  // Avoid a frame of LitLaunch content while the platform flips
  if (!isAfterTide) return <div className={`min-h-screen ${dk.page}`} data-id="element-829" data-mp="1dpnxobyh3al8" />;
  return <>{children}</>;
};
export default AfterTideRoute;